module.exports = "#container {\n  margin: auto;\n  min-height: 12rem; }\n"